import { render } from "./Select2ButtonThemeItem.vue?vue&type=template&id=3f9585fc&scoped=true"
import script from "./Select2ButtonThemeItem.vue?vue&type=script&lang=js"
export * from "./Select2ButtonThemeItem.vue?vue&type=script&lang=js"

import "./Select2ButtonThemeItem.vue?vue&type=style&index=0&id=3f9585fc&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9585fc"]])

export default __exports__